function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ChatPopup = require('./popup');
var ChatManagerTemplate = require('./main.template');
var ChatTeaser = require('./teaser.template');
var JSON = require('json-bigint');
var ChatUserMenu = require('./../overlays/chat-user-menu');
var ChatManagerMenu = require('./../overlays/chat-manager-menu');
var ChatManager = /*#__PURE__*/function () {
  function ChatManager(app, mod) {
    var _this = this;
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, ChatManager);
    this.app = app;
    this.mod = mod;
    this.container = container;

    //
    // some apps may want chat manager quietly in background
    //
    this.render_manager_to_screen = 0;
    this.render_popups_to_screen = 1;

    //
    // track popups
    //
    this.popups = {};
    this.timers = {};
    this.pinged = {};

    //
    // handle requests to re-render chat manager
    //
    app.connection.on('chat-manager-render-request', function () {
      if (_this.render_manager_to_screen) {
        //
        // Rerender the chat manager, sorting the chats by last active
        // and updating unread message notifications
        //
        _this.render();
      } else {
        // chat manager not currently rendered to screen
      }
    });
    app.connection.on('chat-manager-request-no-interrupts', function () {
      _this.render_popups_to_screen = 0;
    });

    //
    // handle requests to re-render chat popups
    //
    app.connection.on('chat-popup-render-request', function () {
      var group = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (!group) {
        group = _this.mod.returnCommunityChat();
      }
      if (group) {
        var _group;
        var popupContainer = ((_group = group) === null || _group === void 0 ? void 0 : _group.target_container) || _this.chat_popup_container || '';
        if (!_this.popups[group.id]) {
          _this.popups[group.id] = new ChatPopup(_this.app, _this.mod, popupContainer);
          _this.popups[group.id].group = group;
        } else {
          _this.popups[group.id].setContainer(popupContainer);
        }
        var popup_rendered = 0;
        if (_this.render_popups_to_screen || _this.popups[group.id].is_rendered) {
          popup_rendered = _this.popups[group.id].render();
        }

        //if (!popup_rendered) {
        //	this.app.connection.emit("chat-group-not-rendered", group);
        //}

        //
        // We use an event so that other components can piggy back off this request
        //
        _this.app.connection.emit('chat-manager-render-request');
      }
    });

    //
    // handle requests to re-render chat popups
    //
    app.connection.on('chat-popup-remove-request', function () {
      var group = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (!group) {
        return;
      } else {
        if (_this.popups[group.id]) {
          _this.popups[group.id].remove();
          delete _this.popups[group.id];
        }
      }
    });
    app.connection.on('chat-manager-animation-request', function () {
      var group = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var cm_handle = document.getElementById("saito-user-".concat(group === null || group === void 0 ? void 0 : group.id));
      if (cm_handle) {
        if (!cm_handle.classList.contains('new-notification')) {
          cm_handle.classList.add('new-notification');
          setTimeout(function () {
            cm_handle.classList.remove('new-notification');
            _this.app.connection.emit('chat-manager-render-request');
          }, 1000);
        }
      }
    });

    // This is a short cut for any other UI components to trigger the chat-popup window
    // (in the absence of a proper chat-manager listing the groups/contacts)

    app.connection.on('open-chat-with', function () {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var popup_status = _this.render_popups_to_screen;
      //Allow this event to force open a chat
      _this.render_popups_to_screen = 1;
      if (_this.mod.debug) {
        console.log('open-chat-with');
      }
      var group = null;
      if (!data) {
        group = _this.mod.returnCommunityChat();
      } else {
        if (data.key) {
          if (Array.isArray(data.key)) {
            group = _this.mod.returnOrCreateChatGroupFromMembers(data.key, data.name);
          } else {
            group = _this.mod.returnOrCreateChatGroupFromMembers([_this.mod.publicKey, data.key], data.name);
          }
        } else {
          console.log('**********', data);
          if (data.id && data.name) {
            _this.mod.createFreshGroup(data.name, data.id);
          }
        }

        //Other modules can specify a chat group id (maybe linked to game_id or league_id)
        if (data.id) {
          var group2 = _this.mod.returnGroup(data.id);
          if (!group2 && group) {
            group.id = data.id;
          } else {
            group = group2;
          }
        }
        if (data !== null && data !== void 0 && data.temporary) {
          group.temporary = true;
        }
      }
      if (_this.mod.browser_active) {
        _this.switchTabs();
      }

      //
      // permit re-open
      //
      if (_this.popups[group.id]) {
        _this.popups[group.id].manually_closed = false;
      }
      app.connection.emit('chat-popup-render-request', group);
      _this.render_popups_to_screen = popup_status;
      _this.popups[group.id].activate();
    });
    app.connection.on('stun-connection-connected', function (peer) {
      app.connection.emit('relay-is-online', peer, true);
    });
    app.connection.on('relay-is-online', function (pkey) {
      var stun = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var target_id = _this.mod.createGroupIdFromMembers([pkey, _this.mod.publicKey]);
      var group = _this.mod.returnGroup(target_id);
      //console.log("Receive online confirmation from " + pkey);
      if (!group || group.members.length !== 2) {
        return;
      }
      if (stun) {
        group.online = ' stun';
      } else {
        group.online = ' online';
      }
      var cm_handle = document.querySelector(".chat-manager #saito-user-".concat(group.id));
      if (cm_handle) {
        cm_handle.classList.add('online');
        if (stun) {
          cm_handle.classList.add('stun');
        }
        if (_this.timers[group.id]) {
          clearTimeout(_this.timers[group.id]);
        }
        _this.timers[group.id] = null;
      }
    });
    app.connection.on('group-is-active', function (group) {
      if (group.members.length !== 2) {
        return;
      }
      if (!group.online) {
        group.online = ' online';
      }
      if (_this.timers[group.id]) {
        clearTimeout(_this.timers[group.id]);
      }
      _this.pinged[group.id] = new Date().getTime();
      _this.timers[group.id] = setTimeout(function () {
        group.online = false;
        app.connection.emit('chat-manager-render-request');
      }, 60000);
    });
  }
  return _createClass(ChatManager, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      //
      // some applications do not want chat-manager appearing (games!)
      //
      if (this.render_manager_to_screen == 0) {
        return;
      }

      //
      // replace element or insert into page
      //
      if (document.querySelector(this.container + '.chat-manager')) {
        this.app.browser.replaceElementBySelector(ChatManagerTemplate(this), '.chat-manager');
      } else {
        if (document.querySelector('.chat-manager')) {
          document.querySelector('.chat-manager').remove();
        }
        this.app.browser.addElementToSelectorOrDom(ChatManagerTemplate(this), this.container);
      }
      var list = document.querySelector('.chat-manager-list.scroll-hint');
      if (list) {
        this.app.browser.makeScrollHint(list);
      }

      // Sort chat groups
      this.mod.groups = this.mod.groups.sort(function (a, b) {
        var ts_a = (a === null || a === void 0 ? void 0 : a.last_update) || 0;
        var ts_b = (b === null || b === void 0 ? void 0 : b.last_update) || 0;
        return ts_b - ts_a;
      });

      //
      // render chat groups
      //
      var now = new Date().getTime();
      var groups_to_ping = [];
      var _iterator = _createForOfIteratorHelper(this.mod.groups),
        _step;
      try {
        var _loop = function _loop() {
          var _this2$popups$group$i;
          var group = _step.value;
          // *****************************************************
          // If this devolves into a DDOS attack against ourselves
          // comment out the following code
          //
          // We only send out a ping on a render if it has been at
          // least a minute since the last ping
          // *****************************************************
          if (group.members.length == 2 && _this2.mod.isRelayConnected) {
            var _iterator2 = _createForOfIteratorHelper(group.members),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var member = _step2.value;
                if (member != _this2.mod.publicKey) {
                  if (!_this2.pinged[group.id] || _this2.pinged[group.id] < now - 60000) {
                    _this2.pinged[group.id] = now;
                    groups_to_ping.push(member);
                    if (_this2.timers[group.id]) {
                      clearTimeout(_this2.timers[group.id]);
                    }

                    //If you don't hear back in 5 seconds, assume offline
                    _this2.timers[group.id] = setTimeout(function () {
                      var cm_handle = document.querySelector(".chat-manager #saito-user-".concat(group.id));
                      if (cm_handle) {
                        cm_handle.classList.remove('online');
                      }
                      group.online = false;
                      _this2.timers[group.id] = null;
                    }, 1000 * 5);
                  }
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
          var group_status = false;
          if ((_this2$popups$group$i = _this2.popups[group.id]) !== null && _this2$popups$group$i !== void 0 && _this2$popups$group$i.is_rendered) {
            group_status = true;
          }
          var html = ChatTeaser(_this2.app, _this2.mod, group, group_status);
          var divid = 'saito-user-' + group.id;
          var obj = document.getElementById(divid);
          if (obj) {
            _this2.app.browser.replaceElementById(html, divid);
          } else {
            if (document.querySelector('.chat-manager-list')) {
              _this2.app.browser.addElementToSelector(html, '.chat-manager-list');
            }
            obj = document.getElementById(divid);
          }
          setTimeout(function () {
            obj.classList.remove('new-notification');
          }, 1000);
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.app.connection.emit('relay-ping-peer', groups_to_ping);
      this.attachEvents();
    }

    /*
      Set popup flags so that we don't auto open any chat groups in the /chat interface
    */
  }, {
    key: "switchTabs",
    value: function switchTabs() {
      for (var popup in this.popups) {
        this.popups[popup].manually_closed = true;
        this.popups[popup].is_rendered = false;
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this3 = this;
      //
      // clicks on the element itself (background)
      //
      document.querySelectorAll('.chat-manager-list .saito-user').forEach(function (item) {
        item.onclick = function (e) {
          e.stopPropagation();
          var gid = e.currentTarget.getAttribute('data-id');
          var group = _this3.mod.returnGroup(gid);
          var popupContainer = (group === null || group === void 0 ? void 0 : group.target_container) || _this3.chat_popup_container || '';
          if (!_this3.popups[gid]) {
            _this3.popups[gid] = new ChatPopup(_this3.app, _this3.mod, popupContainer);
            _this3.popups[gid].group = group;
          } else {
            _this3.popups[gid].setContainer(popupContainer);
          }
          if (_this3.mod.browser_active) {
            _this3.switchTabs();
          }

          // unset manually closed to permit rendering
          _this3.popups[gid].manually_closed = false;
          _this3.popups[gid].render();
          _this3.popups[gid].activate();

          //
          // We would want to force this if juggling multiple chat popups on a desktop
          // because the user is choosing to open the popup, otherwise there are safety
          // catches to keep the focus on the already open text window
          //
          if (!_this3.app.browser.isMobileBrowser()) {
            _this3.popups[gid].input.focus(true);
          }
          _this3.app.connection.emit('chat-manager-render-request');
        };
        item.oncontextmenu = function (e) {
          e.preventDefault();
          var gid = e.currentTarget.getAttribute('data-id');
          var chatMenu = new ChatUserMenu(_this3.app, _this3.mod, _this3.mod.returnGroup(gid));
          chatMenu.render();
        };
      });
      if (document.querySelector('.close-chat-manager')) {
        document.querySelector('.close-chat-manager').onclick = function (e) {
          _this3.app.connection.emit('close-chat-manager-overlay');
        };
      }
      if (document.querySelector('.alternate-close-button')) {
        document.querySelector('.alternate-close-button').onclick = function (e) {
          _this3.app.connection.emit('close-chat-manager-overlay');
        };
      }

      /*if (this.app.browser.isMobileBrowser() || window.innerWidth < 600){
        this.app.connection.emit("saito-header-replace-logo", () => {
          this.app.connection.emit("close-chat-manager-overlay");
        });
      }*/

      if (document.querySelector('.chat-manager-options')) {
        document.querySelector('.chat-manager-options').onclick = function (e) {
          _this3.mod.loadSettings();
        };
      }
    }
  }]);
}();
module.exports = ChatManager;